import React from "react";
import { Select as MuiSelect, MenuItem } from "@mui/material";

const CustomSelect = ({ name, value, options, onChange, ...props }) => {
  return (
    <MuiSelect
      name={name}
      value={value}
      onChange={onChange}
      fullWidth
      displayEmpty
      renderValue={(selected) => {
        const item = options?.find((item) => {
          return item.value === selected;
        });
        return item?.label;
      }}
      {...props}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            display: option?.value === "" ? "none" : "block",
          }}
          hidden={option?.value === ""}
        >
          {option.label}
        </MenuItem>
      ))}
    </MuiSelect>
  );
};

export default CustomSelect;
